import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {IndustriepartnerHttpService} from '../core/services/industriepartner-http.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AuthService} from '../core/services/auth.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {DeleteDeactivateModalComponent} from '../modals/delete-deactivate-modal/delete-deactivate-modal.component';
import {AlertService} from '../core/services/alert.service';

@Component({
  selector: 'app-industriepartner-details',
  templateUrl: './industriepartner-details.component.html',
  styleUrls: ['./industriepartner-details.component.scss']
})
export class IndustriepartnerDetailsComponent implements OnInit {

  public loading = false;
  public loadingSubs = false;
  public industriepartner = null;
  public industriepartnerAuth = null;
  public subIndustriepartner = new MatTableDataSource();
  public filteredSubIndustriepartner = new MatTableDataSource();
  public user;

  constructor(public auth: AuthService, activatedRoute: ActivatedRoute, public router: Router,
              public dialog: MatDialog, public alert: AlertService,
              public industriePartnerService: IndustriepartnerHttpService, public snack: MatSnackBar) {
    this.loading = true;
    activatedRoute.paramMap.subscribe(params => {
      let anbieterNr = params['params']['anbieterNr'];
      this.industriePartnerService.getIndustriepartner(anbieterNr).subscribe(res => {
        this.loading = false;
        this.industriepartner = res['industriepartner'];
        this.industriepartnerAuth = res['industriepartnerAuth'];
        this.loadSubs();
      }, err => {
        this.loading = false;
        this.snack.open('Fehler beim Öffnen des Industriepartners '+anbieterNr, '', {panelClass: 'danger-snackbar'});
        if(err.status == 403 || err.status == 404) {
          this.router.navigateByUrl('/');
        }
      })
    });
    auth.currentUser.subscribe(user => {
      this.user = user;
    });
  }

  ngOnInit(): void {
  }

  private loadSubs() {
    this.loadingSubs = true;
    this.auth.getSubs(this.industriepartner.kundennumm).subscribe(res => {
      this.loadingSubs = false;
      this.subIndustriepartner.data = res as [];
      this.filteredSubIndustriepartner.data = res as [];
    }, err => {
      this.loadingSubs = false;
      this.snack.open('Fehler beim Zugriff auf die Mitarbeiter.', '', {panelClass: 'danger-snackbar'});
      if(err.status == 403)
        this.router.navigateByUrl('/');
    })
  }

  deactivate() {
    this.dialog.open(DeleteDeactivateModalComponent, {
      data: {
        deactivate: true,
        object: this.industriepartner,
        name: this.industriepartner.nama
      }
    }).afterClosed().subscribe(res => {
      if(!res)
        return;
      this.industriePartnerService.deactivateIndustriepartner(this.industriepartnerAuth.kundenkennung).subscribe(res => {
        this.industriepartnerAuth.gesperrt = true;
        this.snack.open('Industriepartner wurde erfolgreich deaktiviert.', '', {panelClass: 'success-snackbar'});
      }, err => {
        this.snack.open('Fehler beim Zugriff auf den Industriepartner.', '', {panelClass: 'danger-snackbar'});
        if(err.status == 403)
          this.router.navigateByUrl('/');
      });
    });
  }

  activate() {
    this.industriePartnerService.activateIndustriepartner(this.industriepartnerAuth.kundenkennung).subscribe(res => {
      this.industriepartnerAuth.gesperrt = false;
      this.snack.open('Industriepartner wurde erfolgreich aktiviert.', '', {panelClass: 'success-snackbar'});
    }, err => {
      this.snack.open('Fehler beim Zugriff auf den Industriepartner.', '', {panelClass: 'danger-snackbar'});
      if(err.status == 403)
        this.router.navigateByUrl('/');
    });
  }

  addSubIndustriepartner() {
    let sub = {
      edit: true,
      kundenkennung: null,
      kundennummer: this.industriepartner.kundennumm,
      vorname: '',
      nachname: '',
      email: '',
      saving: false
    };
    this.subIndustriepartner.data = [...this.subIndustriepartner.data, sub];
    this.filteredSubIndustriepartner.data = [...this.filteredSubIndustriepartner.data, sub];
  }

  saveSubIndustriepartner(subData) {
    subData.saving = true;
    this.industriePartnerService.addIndustriepartnerSub(subData).subscribe(res => {
      subData.saving = false;
      subData.kundenkennung = res['kundenkennung'];
      subData.edit = false;
      this.snack.open('Mitarbeiter erfolgreich hinzugefügt.', '', {panelClass: 'success-snackbar'});
    }, err => {
      subData.saving = false;
      this.alert.showValidationError(err);
      this.alert.showCustomValidationError(err);
    })
  }

  deleteSubIndustriepartner(subData) {
    this.dialog.open(DeleteDeactivateModalComponent, {
      data: {
        name: subData.kundenkennung,
        object: subData,
      }
    }).afterClosed().subscribe(res => {
      if(!res) {
        return;
      }
      subData.saving = true;
      this.auth.deleteSub(subData.kundenkennung).subscribe(res => {
        subData.saving = false;
        this.loadSubs();
      }, err => {
        this.snack.open('Fehler beim Löschen des Mitarbeiters.', '', {panelClass: 'danger-snackbar'});
        subData.saving = false;
      })
    });
  }

  public authIndForm = {
    anbieterNr: '',
    vorname: '',
    nachname: '',
    email: '',
    phone: ''
  };
  public creatingAuth = false;
  public newPassword = '';
  addIndustrieAuth() {
    this.creatingAuth = true;
    this.authIndForm.anbieterNr = this.industriepartner.anbieternummer;
    this.industriePartnerService.addIndustriepartnerAuth(this.authIndForm).subscribe(res => {
      this.creatingAuth = false;
      this.newPassword = res['password']; 
      this.industriepartnerAuth = res['userAuthentication'];
    }, err => {
      this.creatingAuth = false;
      if(err.status == 400) {
        let e = err.error.errors.map(e => e.defaultMessage).join(', ');
        this.snack.open(e, '', {panelClass: 'danger-snackbar'});
      }
      console.log(err);
    });
  }

  validAddAuthForm() {
    return this.authIndForm.vorname.length > 0 && 
      this.authIndForm.nachname.length > 0 && 
      this.authIndForm.email.length > 0 &&
      this.authIndForm.phone.length > 0;
  }
}
